import React, { Component } from 'react'
import { connect } from 'react-redux'

import { clientSide } from '../../config_react.js'
const { redirectToStorage } = clientSide[0]

export default class AddServices extends Component {
    constructor(props) {
        super(props)

        this.state = {}

        this.service = React.createRef()
    }

    render() {
        return (
            <div className="addServices">
                <div className="addServicesScroll">{this.servicesList()}</div>
            </div>
        )
    }

    servicesList = () => {
        let list = this.props.servicesList.map((item, i) => {
            if (this.props.userPermissions.length) {
                let selectedCard = false
                this.props.userPermissions.forEach(s => {
                    if (s.dappAddress === item.id && s.grantAccess) {
                        selectedCard = true
                    }
                })
                if (selectedCard) {
                    return (
                        <div
                            key={item.id}
                            onClick={e => this.select(e, i + 1, item.id)}
                            className="card selectedСard"
                        >
                            <p>{item.name}</p>
                        </div>
                    )
                } else {
                    return (
                        <div
                            key={item.id}
                            onClick={e => this.select(e, i + 1, item.id)}
                            className="card"
                        >
                            <p>{item.name}</p>
                        </div>
                    )
                }
            } else {
                return (
                    <div
                        key={item.id}
                        onClick={e => this.select(e, i + 1, item.id)}
                        className="card"
                    >
                        <p>{item.name}</p>
                    </div>
                )
            }
        })

        return list
    }

    select = (e, data, dappEth) => {
        let result = null
        let userPermissions = this.props.userPermissions
        let driveFileId = this.props.driveFileId
        let servicesList = this.props.servicesList

        userPermissions.forEach(item => {
            if (item.dappAddress == dappEth) {
                result = !item.grantAccess
            }
        })

        if (result === null) result = true

        let type = result ? 'add' : 'delete'

        if (dappEth !== undefined) {
            this.props.switchServicesInfo(
                type,
                servicesList[data - 1].name,
                dappEth
            )
        }

        console.log(`/paconnectservice:dappEthAddress: ${dappEth}`)
        console.log(`/paconnectservice:driveFileId: ${driveFileId}`)
        console.log(`/paconnectservice:grantAccess: ${result}`)

        fetch(
            `${redirectToStorage}/paconnectservice?dappEthAddress=${dappEth}&driveFileId=${driveFileId}&grantAccess=${result}`,
            {
                method: 'GET',
                headers: {
                    Cache: 'no-cache',
                },
                credentials: 'include',
            }
        )
            .then(response => response.json())
            .then(data => {
                console.log(`return: /paconnectservice`)
                console.log(data)
                if (data.result) {
                    this.props.updateData()
                } else {
                    console.log(
                        `${redirectToStorage}/paconnectservice?dappEthAddress=${dappEth}&driveFileId=${driveFileId}&grantAccess=${result} error`,
                        data
                    )
                }
            })
            .catch(err => {
                console.log(err)
            })
    }
}
